import { render, staticRenderFns } from "./CytomineTable.vue?vue&type=template&id=5f5e0c19"
import script from "./CytomineTable.vue?vue&type=script&lang=js"
export * from "./CytomineTable.vue?vue&type=script&lang=js"
import style0 from "./CytomineTable.vue?vue&type=style&index=0&id=5f5e0c19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports